/**
 * TanStack Query hooks for `igaming-wager-tracking`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingWagerTrackingQueryKeys,
	type CreateIgamingWagerTrackingBody,
	type ListIgamingWagerTrackingResponse,
	type IgamingWagerTrackingRow,
} from "./api";

export function useIgamingWagerTrackingList(): UseQueryResult<ListIgamingWagerTrackingResponse, Error> {
	return useQuery({
		queryKey: igamingWagerTrackingQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingWagerTrackingCreate(): UseMutationResult<IgamingWagerTrackingRow, Error, CreateIgamingWagerTrackingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingWagerTrackingQueryKeys.all });
		},
	});
}

export function useIgamingWagerTrackingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingWagerTrackingQueryKeys.all });
		},
	});
}
